<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
.formWrapper .header {
  height: 54px;
  line-height: 54px;
  color: #404d54;
  font-size: 20px;
  border-bottom: 1px solid #eeeeee;
  position: relative;
}
.formWrapper .header:before {
  content: "";
  position: absolute;
  left: -24px;
  top: 50%;
  transform: translate(0, -50%);
  -ms-transform: translate(0, -50%); /* IE 9 */
  -webkit-transform: translate(0, -50%); /* Safari and Chrome */
  background-size: cover;
  display: inline-block;
  width: 3px;
  height: 17px;
  background: #1e87f0;
}

/*
必須マーク
*/
.mandatory .el-form-item__label:after {
  content: "*";
  color: #ff0000;
}
.mandatory .cell:after {
  content: "*";
  color: #ff0000;
}

/*
テーブル関係
*/
.tableWrapper .header {
  height: 54px;
  line-height: 54px;
  color: #404d54;
  font-size: 20px;
  border-bottom: 1px solid #eeeeee;
  position: relative;
}
.tableWrapper .header:before {
  content: "";
  position: absolute;
  left: -24px;
  top: 50%;
  transform: translate(0, -50%);
  -ms-transform: translate(0, -50%); /* IE 9 */
  -webkit-transform: translate(0, -50%); /* Safari and Chrome */
  background-size: cover;
  display: inline-block;
  width: 3px;
  height: 17px;
  background: #1e87f0;
}
.tableBox {
  margin-top: 30px;
}
.el-table td {
  border-bottom: 5px solid #f8f8f8;
}
.el-table__header {
  border-radius: 10px 10px 0 0;
  overflow: hidden;
}
.el-table__header tr th {
  background: #000000 !important;
  color: #fff;
}
.el-table--scrollable-y .el-table__body-wrapper ::-webkit-scrollbar {
  width: 10px; /*对垂直流动条有效*/
  height: 10px; /*对水平流动条有效*/
}
.el-table--scrollable-y .el-table__body-wrapper ::-webkit-scrollbar-track {
  border: 1px solid #ccc;
  background-color: #fff;
  border-radius: 3px;
}
.el-table--scrollable-y .el-table__body-wrapper ::-webkit-scrollbar-thumb {
  border-radius: 7px;
  background-color: #0f3d5f;
}

.page {
  text-align: right;
  font-size: 14px;
  line-height: 50px;
}

.clearfix {
  *zoom: 1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue